import React from 'react'
import classnames from 'classnames'

export default function Tabs(){

  function postProgramIsActive(){
    const reqFrom = window.URLQueryParams()['reqFrom']
    return reqFrom == 'post_program_data'
  }

  return(
    <ul className="nav nav-tabs" id="outcomesTab" role="tablist">
      <li className="nav-item w-50">
        <a 
          className={classnames("nav-link", "text-center", "title", {
            "active" : !postProgramIsActive()
          })}
          id="home-tab" 
          data-toggle="tab" 
          href="#home" 
          role="tab" 
          aria-controls="home" 
          aria-selected={(!postProgramIsActive()).toString()}>Program Data</a>
      </li>
      <li className="nav-item w-50">
        <a 
          className={classnames("nav-link", "text-center", "title", {
            "active" : postProgramIsActive()
          })} 
          id="profile-tab" 
          data-toggle="tab" 
          href="#profile" 
          role="tab" 
          aria-controls="profile" 
          aria-selected={postProgramIsActive()}>Post Program Data</a>
      </li>
    </ul>
  )
}